import { render, staticRenderFns } from "./SettingJournal.vue?vue&type=template&id=77c753c9"
import script from "./SettingJournal.vue?vue&type=script&lang=js"
export * from "./SettingJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports